React = require 'react'
t = require('views/internal/recup-with-helpers')('org_ads')
track = require 'debug/track'
ldclient = require 'lib/ldclient'

class OrganizationMembersAd extends React.Component
  constructor: (props) ->
    super
    @dismissAndTrack = @dismissAndTrack.bind(@)

  dismissAndTrack: ->
    track('Organization View', 'Members Page', 'Dismiss Security Ad')
    @props.dismissAd()

  render: t.renderable ->
    { billingUrl } = @props

    t.div '.org-ad.org-ad-members.ads-layout-experiment', =>
      t.button '.close-ad', { onClick: @dismissAndTrack }, ->
        t.icon 'close'

      t.div '.org-ad-body', =>
        t.p '.org-ad-title', ->
          t.format 'ads-title-members'
        t.p '.org-ad-text', ->
          t.format 'ads-text-members'
        t.a '.org-ad-learn-more', { href: '/business-class', target: '_blank', onClick: -> track('Organization View', 'Boards Page', 'Learn more') }, ->
          t.format 'ads-learn-more'
        t.a '.button.primary', { href: billingUrl, onClick: -> track('Organization View', 'Members Page', 'Upgrade Button') }, ->
          t.format 'ads-upgrade'

class OrganizationBoardsAd extends React.Component
  constructor: (props) ->
    super
    @dismissAndTrack = @dismissAndTrack.bind(@)
    @onLdUpdate = @onLdUpdate.bind(@)
    @state = {
      boardLimitsFlag: ldclient.variation('bc.board_limits', false)
    }

  dismissAndTrack: ->
    track('Organization View', 'Boards Page', 'Dismiss Collections Ad')
    @props.dismissAd()

  onLdUpdate: (newVal) ->
    @setState({ boardLimitsFlag: newVal })

  componentDidMount: ->
    ldclient.on 'change:bc.board_limits', @onLdUpdate

  componentWillUnmount: ->
    ldclient.off 'change:bc.board_limits', @onLdUpdate

  render: t.renderable ->
    { billingUrl } = @props
    { boardLimitsFlag } = @state

    t.div '.org-ad.org-ad-boards.ads-layout-experiment', =>
      t.button '.close-ad', { onClick: @dismissAndTrack }, ->
        t.icon 'close'

      if boardLimitsFlag
        t.div '.org-ad-body', =>
          t.img '.org-upsell-image', { src: require('images/organization/unlimited-boards.png') }
          t.p '.org-ad-title', ->
            # TODO board-limits-copy - add 'ads-unlimited-boards' to app/scripts/data/template-strings/org_ads.json
            t.text 'Get Unlimited Boards with Business Class.'
          t.a '.org-ad-learn-more', { href: '/business-class', target: '_blank', onClick: -> track('Organization View', 'Boards Page', 'Learn more') }, ->
            t.format 'ads-learn-more'
          t.a '.button.primary', { href: billingUrl, onClick: -> track('Organization View', 'Boards Page', 'Upgrade Button') }, ->
            t.format 'ads-upgrade'
      else
        t.div '.org-ad-body', =>
          t.img '.org-upsell-image', { src: require('images/collections/business-class-feature-roadmap.png') }
          t.p '.org-ad-title', ->
            t.format 'ads-title-boards'
          t.p '.org-ad-text', ->
            t.format 'ads-text-boards'
          t.a '.org-ad-learn-more', { href: '/business-class', target: '_blank', onClick: -> track('Organization View', 'Boards Page', 'Learn more') }, ->
            t.format 'ads-learn-more'
          t.a '.button.primary', { href: billingUrl, onClick: -> track('Organization View', 'Boards Page', 'Upgrade Button') }, ->
            t.format 'ads-upgrade'

module.exports = {
  OrganizationMembersAd,
  OrganizationBoardsAd
}



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-ad-component.coffee